/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function ActionTrigger(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'ActionTrigger',
      'aria-hidden': true,
      focusable: false,
      width:  12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('defs', null,createElement('path', {"id":"wf-svg-ActionTrigger-__a","d":"M6 7H2.5L6 1.5V5h3.5L6 10.5z"})),createElement('g', {"fill":"none","fillRule":"evenodd"},createElement('rect', {"width":"12","height":"12","fill":"#008547","rx":"1"}),createElement('use', {"fill":"#FFF","opacity":".9","xlinkHref":"#wf-svg-ActionTrigger-__a"})))
}
